/** Auto-generated Excel column/header enums for spa exports. */

export enum SpaExcelHeader {
  AKA = "AKA",
  AddOnName = "AddOnName",
  AddOns = "AddOns",
  AddressLine1 = "AddressLine1",
  AddressLine2 = "AddressLine2",
  AddressLine3 = "AddressLine3",
  AllowCommission = "AllowCommission",
  AllowGratuity = "AllowGratuity",
  AllowPriceChange = "AllowPriceChange",
  AllowServiceCharge = "AllowServiceCharge",
  AllowTaxOnGratuity = "AllowTaxOnGratuity",
  AllowTaxOnServiceCharge = "AllowTaxOnServiceCharge",
  AutoGratuity = "AutoGratuity",
  AutoReceipt = "AutoReceipt",
  AutoServiceCharge = "AutoServiceCharge",
  Available = "Available",
  AvailableOnWeb = "AvailableOnWeb",
  BreakdownTime = "BreakdownTime",
  CancellationPolicy = "CancellationPolicy",
  Category = "Category",
  CategoryGroup = "CategoryGroup",
  CategoryGroupName = "CategoryGroupName",
  City = "City",
  Code = "Code",
  Color = "Color",
  Comments = "Comments",
  Commisionable = "Commisionable",
  CommissionClassId = "CommissionClassId",
  Commissionable = "Commissionable",
  ContactDetail = "ContactDetail",
  ContactLocation = "ContactLocation",
  ContactType = "ContactType",
  Country = "Country",
  DateOfHire = "DateOfHire",
  Description = "Description",
  DiscountReason = "DiscountReason",
  DiscountType = "DiscountType",
  DisplayOnAppointmentGrid = "DisplayOnAppointmentGrid",
  EffectiveFromDate = "EffectiveFromDate",
  EffectiveToDate = "EffectiveToDate",
  EligibleForDiscount = "EligibleForDiscount",
  EligibleForCostOrCostPlus = "EligibleForCostOrCostPlus",
  EligibleForInHouseServiceChargeCalculation = "EligibleForInHouseServiceChargeCalculation",
  EndDate = "EndDate",
  EquipmentCode = "EquipmentCode",
  FirstName = "FirstName",
  Gender = "Gender",
  GratuityAmount = "GratuityAmount",
  GratuityPercent = "GratuityPercent",
  GuestTypeCode = "GuestTypeCode",
  GuestTypeDescription = "GuestTypeDescription",
  HourlyRate = "HourlyRate",
  IncrementDecrement = "IncrementDecrement",
  IsActive = "IsActive",
  IsAmountOrPercentage = "IsAmountOrPercentage",
  IsAutomaticRecap = "IsAutomaticRecap",
  IsAvailableOnFriday = "IsAvailableOnFriday",
  IsAvailableOnMonday = "IsAvailableOnMonday",
  IsAvailableOnSaturday = "IsAvailableOnSaturday",
  IsAvailableOnSunday = "IsAvailableOnSunday",
  IsAvailableOnThursday = "IsAvailableOnThursday",
  IsAvailableOnTuesday = "IsAvailableOnTuesday",
  IsAvailableOnWeb = "IsAvailableOnWeb",
  IsAvailableOnWednesday = "IsAvailableOnWednesday",
  IsDefault = "IsDefault",
  IsDefaultCancelPolicy = "IsDefaultCancelPolicy",
  IsDefaultTax = "IsDefaultTax",
  IsFixedComponent = "IsFixedComponent",
  IsInactive = "IsInactive",
  IsPrimary = "IsPrimary",
  IsPrivate = "IsPrivate",
  IsPrivateInfo = "IsPrivateInfo",
  IsSelectCompAtBooking = "IsSelectCompAtBooking",
  IsTopCompAtBooking = "IsTopCompAtBooking",
  IsUtilized = "IsUtilized",
  LastName = "LastName",
  Level = "Level",
  LinkedRetailItemCode = "LinkedRetailItemCode",
  ListOrder = "ListOrder",
  LocationCodes = "LocationCodes",
  LogType = "LogType",
  MaxGuests = "MaxGuests",
  MaximumGuest = "MaximumGuest",
  MaximumNoOfDays = "MaximumNoOfDays",
  MaximumStaff = "MaximumStaff",
  MedicalConditionCodes = "MedicalConditionCodes",
  MinimumAge = "MinimumAge",
  MinimumGuest = "MinimumGuest",
  MinimumStaff = "MinimumStaff",
  Name = "Name",
  NoOfPeoples = "NoOfPeoples",
  NumberOfItems = "NumberOfItems",
  NumberOfReceipts = "NumberOfReceipts",
  NumberOfRetailItems = "NumberOfRetailItems",
  OffSite = "OffSite",
  OutletName = "OutletName",
  Outlets = "Outlets",
  POSEndPoint = "POSEndPoint",
  PackageClass = "PackageClass",
  PackageCode = "PackageCode",
  PackageDescription = "PackageDescription",
  PackageEndDate = "PackageEndDate",
  PackagePoints = "PackagePoints",
  PackagePolicy = "PackagePolicy",
  PackagePrice = "PackagePrice",
  PackageStartDate = "PackageStartDate",
  PaymentMethodName = "PaymentMethodName",
  Percentage = "Percentage",
  PostalCode = "PostalCode",
  Price = "Price",
  PriceFri = "PriceFri",
  PriceFriday = "PriceFriday",
  PriceMon = "PriceMon",
  PriceMonday = "PriceMonday",
  PriceSat = "PriceSat",
  PriceSaturday = "PriceSaturday",
  PriceSun = "PriceSun",
  PriceSunday = "PriceSunday",
  PriceThu = "PriceThu",
  PriceThursday = "PriceThursday",
  PriceTue = "PriceTue",
  PriceTuesday = "PriceTuesday",
  PriceTypeCode = "PriceTypeCode",
  PriceWed = "PriceWed",
  PriceWednesday = "PriceWednesday",
  ProfitCenter = "ProfitCenter",
  Quantity = "Quantity",
  ReasonCode = "ReasonCode",
  RepresentativeFname = "RepresentativeFname",
  RepresentativeLname = "RepresentativeLname",
  RequireComment = "RequireComment",
  RequireQuantity = "RequireQuantity",
  RequireReceipts = "RequireReceipts",
  RequireSignatureCapture = "RequireSignatureCapture",
  RetailCategoryName = "RetailCategoryName",
  RetailItemNumber = "RetailItemNumber",
  SeniorityLevel = "SeniorityLevel",
  ServiceChargeAmount = "ServiceChargeAmount",
  ServiceChargePercent = "ServiceChargePercent",
  ServiceCode = "ServiceCode",
  ServiceColorCode = "ServiceColorCode",
  ServiceComments = "ServiceComments",
  ServiceCount = "ServiceCount",
  ServiceDescription = "ServiceDescription",
  ServiceGroupCode = "ServiceGroupCode",
  ServicePoints = "ServicePoints",
  ServicePolicy = "ServicePolicy",
  ServicePrice = "ServicePrice",
  ServiceTime = "ServiceTime",
  SetupTime = "SetupTime",
  StartDate = "StartDate",
  State = "State",
  TaxName = "TaxName",
  TaxValue = "TaxValue",
  TerminalId = "TerminalId",
  TherapistCode = "TherapistCode",
  TherapistCodes = "TherapistCodes",
  Type = "Type",
  Value = "Value",
  VendorCode = "VendorCode",
  VendorName = "VendorName",
  VendorType = "VendorType",
  Warning = "Warning",
}

export enum SpaExcelSourceField {
  Empty = "",
  N000 = "0.00",
  AKA = "AKA",
  Active = "Active",
  AddOnName = "Add On Name",
  Address = "Address",
  AllowCommission = "Allow Commission",
  AllowGratuity = "Allow Gratuity",
  AllowServiceCharge = "Allow Service Charge",
  AllowTaxOnGratuity = "Allow Tax on Gratuity",
  AllowTaxOnServiceCharge = "Allow Tax on Service Charge",
  AutoGratuity = "Auto Gratuity",
  AutoGratuity2 = "Auto Gratuity %",
  AutoPrintsReceipts = "Auto Prints Receipts",
  AutoServiceCharge = "Auto Service Charge",
  AutoServiceCharge2 = "Auto Service Charge %",
  AvailableFri = "Available Fri",
  AvailableMon = "Available Mon",
  AvailableSat = "Available Sat",
  AvailableSun = "Available Sun",
  AvailableThu = "Available Thu",
  AvailableTue = "Available Tue",
  AvailableWed = "Available Wed",
  AvailableOnWeb = "Available on Web",
  BreakCode = "Break Code",
  BreakName = "Break Name",
  BreakdownTime = "Breakdown Time",
  CancelReasonDescription = "Cancel Reason Description",
  Capacity = "Capacity",
  CategoryGroup = "Category Group",
  CategoryName = "Category Name",
  City = "City",
  Color = "Color",
  Comments = "Comments",
  CommissionClass = "Commission Class",
  Commissionable = "Commissionable",
  ConditionCode = "Condition Code",
  ConditionDescription = "Condition Description",
  ConditionWarning = "Condition Warning",
  ContactDetail = "Contact Detail",
  ContactLocation = "Contact Location",
  ContactType = "Contact Type",
  Country = "Country",
  DateOfHire = "Date of Hire",
  DefaultToAllRetailItems = "Default to all Retail Items",
  DiscountReason = "Discount Reason",
  DiscountType = "Discount Type",
  DisplayOnAppointmentGrid = "Display on Appointment Grid",
  EffectiveFromDate = "Effective From Date",
  EffectiveToDate = "Effective To Date",
  EligibleForDiscount = "Eligible for Discount",
  EligibleForCostOrCostPlus = "Eligible for Cost Plus",
  EligibleForInHouseServiceChargeCalculation = "Eligible for In House Service Charge",
  EndDate = "End Date",
  EquipmentCode = "Equipment Code",
  EquipmentDescription = "Equipment Description",
  FirstName = "First Name",
  Gender = "Gender",
  GuestTypeCode = "Guest Type Code",
  GuestTypeName = "Guest Type Name",
  HourlyRate = "Hourly Rate",
  Inactive = "Inactive",
  IsPrimary = "Is Primary",
  IsPrivateInfo = "Is Private Info",
  IsUtilized = "IsUtilized",
  LastName = "Last Name",
  LinkedItem = "Linked Item",
  ListOrder = "List Order",
  LocationCode = "Location Code",
  LocationDescription = "Location Description",
  LocationName = "Location Name",
  LogTypeName = "Log Type Name",
  MaximumGuests = "Maximum Guests",
  MaximumStaff = "Maximum Staff",
  MinimumAge = "Minimum Age",
  MinimumGuests = "Minimum Guests",
  MinimumStaff = "Minimum Staff",
  Offsite = "Offsite",
  Outlet = "Outlet",
  OutletName = "Outlet Name",
  PackageCode = "Package Code",
  PackageDescription = "Package Description",
  PaymentMethodName = "Payment Method Name",
  PercentageOrFlatAmount = "Percentage or Flat Amount",
  Points = "Points",
  PostalCode = "Postal Code",
  Price = "Price",
  PriceTypeCode = "Price Type Code",
  PriceTypeDescription = "Price Type Description",
  PrivateCondition = "Private Condition",
  ProfitCenterID = "Profit Center ID",
  Quantity = "Quantity",
  QuickSaleCategory = "Quick Sale Category",
  ReasonDescription = "Reason Description",
  RequireQuantity = "Require Quantity",
  RetailCategory = "Retail Category",
  RetailItemNumber = "Retail Item Number",
  SeniorityLevel = "Seniority Level",
  ServiceCode = "Service Code",
  ServiceComment = "Service Comment",
  ServiceDescription = "Service Description",
  ServiceGroupCode = "Service Group Code",
  ServiceGroupName = "Service Group Name",
  ServiceLocations = "Service Locations",
  ServicePoints = "Service Points",
  ServicePrice = "Service Price",
  ServiceTime = "Service Time",
  SetupTime = "Setup Time",
  StaffCode = "Staff Code",
  StartDate = "Start Date",
  State = "State",
  SubCategoryName = "Sub Category Name",
  SubCategoryNumber = "Sub Category Number",
  TaxName = "Tax Name",
  TerminalID = "Terminal ID",
  Value = "Value",
  VendorCode = "Vendor Code",
  VendorName = "Vendor Name",
  VendorType = "Vendor Type",
}

export enum SpaExcelSheetName {
  AddOn = "AddOn",
  BreakTypes = "BreakTypes",
  CancelReason = "CancelReason",
  Category = "Category",
  CategoryGroup = "CategoryGroup",
  DiscountReasons = "DiscountReasons",
  DiscountTypes = "DiscountTypes",
  Equipments = "Equipments",
  GuestType = "GuestType",
  Locations = "Locations",
  LogType = "LogType",
  LostDeniedReason = "LostDeniedReason",
  MedicalConditions = "MedicalConditions",
  Outlet = "Outlet",
  PackageAvailableDays = "PackageAvailableDays",
  PackageComponents = "PackageComponents",
  PackageDetail = "PackageDetail",
  PackageYield = "PackageYield",
  PaymentMethod = "PaymentMethod",
  PriceTypes = "PriceTypes",
  QuickSaleCategory = "QuickSaleCategory",
  RetailItem = "RetailItem",
  ServiceAvailableDays = "ServiceAvailableDays",
  ServiceDetail = "ServiceDetail",
  ServiceEquipment = "ServiceEquipment",
  ServiceGroups = "ServiceGroups",
  ServicePriceType = "ServicePriceType",
  ServiceSeasonalDate = "ServiceSeasonalDate",
  ServiceTherapist = "ServiceTherapist",
  SubCategory = "SubCategory",
  Tax = "Tax",
  Therapist = "Therapist",
  TherapistAddOn = "TherapistAddOn",
  TherapistContact = "TherapistContact",
  Vendor = "Vendor",
  VendorContactInformation = "VendorContactInformation",
  VendorType = "VendorType",
}
